module.exports = __webpack_public_path__ + "static/img/16.9b2602e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/16.png
// module id = coWL
// module chunks = 0